/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { Tooltip, Toast, Popover } from 'bootstrap';

document.querySelector('.set-height').style.height = 'calc(100vh - ' +   document.querySelector('.measure-height').offsetHeight + 'px)';
